import dashboardImage from "../assets/logo-icon.png";
import forwardIcon from "../assets/forward-icon.png";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";

const translations = {
  en: {
    welcome: "Welcome",
    analyzeProfile: "Let's analyze your profile and discover your perfect career fit!",
    startAnalysis: "Start Your AI-Powered Career Analysis",
    uploadDescription: "Upload your CV, motivation letter & LinkedIn profile to generate a deep personality and career fit analysis.",
    getStarted: "Get Started"
  },
  nl: {
    welcome: "Welkom",
    analyzeProfile: "Laten we je profiel analyseren en je perfecte carrière match ontdekken!",
    startAnalysis: "Start Je AI-Gestuurde Carrière Analyse",
    uploadDescription: "Upload je CV, motivatiebrief & LinkedIn profiel om een diepgaande persoonlijkheids- en carrière analyse te genereren.",
    getStarted: "Aan de Slag"
  }
};

function Dashboard() {
  const navigate = useNavigate();
  const isDutch = Cookies.get('isDutch') === 'true';
  const t = translations[isDutch ? 'nl' : 'en'];

  const handleGetStarted = () => {
    navigate("/upload");
  }

  return (
    <div className="m-0 text-left">
      <div className="">
      <h1 className="text-5xl font-bold mb-1 text-primary">{t.welcome} {Cookies.get('email')} 👋,</h1>
      <p className="text-gray-500 mt-2">{t.analyzeProfile}</p>
      </div>
      <div className="border bg-secondary p-8 rounded-md mt-20 w-fit fadeUp">
      <div className="flex flex-row gap-4 items-center mb-4">
        <img src={dashboardImage} alt="dashboard" className="w-8 h-8"/>
        <h2 className="text-2xl font-bold fadeUp">{t.startAnalysis}</h2>
        </div>  
          <p className="text-gray-500 mb-4 fadeUp">{t.uploadDescription}</p>
          <button
          onClick={handleGetStarted}
          className="w-fit bg-buttonColor px-4 py-2 rounded-md flex flex-row gap-2 items-center fadeUp hover:bg-opacity-90 transition-colors">
            <p className="text-white">{t.getStarted}</p>
            <img src={forwardIcon} alt="forward" className="h-3 arrow-icon"/>
          </button>
        <div>
          
        </div>
      </div>
    </div>
  );
}

export default Dashboard; 